module.exports = __webpack_public_path__ + "img/dianha.edb5130b.png";